<template>
  <a-layout class='index animated fadeIn'>
    <div class="data-content-nav s_flex_ali">
      <div class="data-content-nav-item flex_1 s_flex_center">
        <div>
          <p class='title'>账号余额</p>
          <p class='num'>0</p>
        </div>
      </div>
      <div class="data-content-nav-item flex_1 s_flex_center">
        <div>
          <p class='title'>
            总使用金额</p>
          <p class='num'>0</p>
        </div>
      </div>
      <div class="data-content-nav-item flex_1 s_flex_center">
        <div>
          <p class='title'>累计充值金额</p>
          <p class='num'>0</p>
        </div>
      </div>
    </div>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="时间" name='time'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='data'>
      </a-table>
      <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getBonusSendList } from "@/api/red";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  start_time: "",
  end_time: "",
};
let defInvite = {
  name: "",
  dealer_sn: "",
  level_id: undefined,
};
export default {
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    let form = ref(defInvite);
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      list: [],
      listLoading: false,
      time: [],
      total: 1,
      level: null,
    });
    let columns = [
      {
        title: "时间",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "使用/充值金额",
        dataIndex: "type",
        key: "type",
      },
      {
        title: "红包金额",
        dataIndex: "amount",
        key: "amount",
      },
      {
        title: "使用/充值方式",
        dataIndex: "author",
        key: "author",
      },
    ];
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      initData(search.value);
    };
    const initData = async (values) => {
      state.listLoading = true;
      data.value = [];
      try {
        let res = await getBonusSendList(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    onMounted(() => {
      initData(search.value);
    });
    const inputSelect = (e) => {
      search.value.keywords = "";
    };
    return {
      ...toRefs(state),
      search,
      form,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      inputSelect,
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #fbfcfc;
  border-radius: 10px;
  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    .title {
      font-size: 16px;
      color: #000000;
    }
    .num {
      font-size: 34px;
      color: #000;
    }
    img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }

    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
    }
  }
}
</style>